import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';
import LoadingButton from '../LoadingButton';

export const PageContainer = styled('div')(`
  padding: 24px;
`);

export const PageHeader = styled('div')(`
  display: flex;
  justify-content: space-between;
  align-items: center;
`);

export const PageTitle = styled(Typography)(`
  font-weight: 700;
  font-size: 24px;
  color: ${COLOR_TEXT_MAIN};
`);

export const PaperButton = styled(LoadingButton)(`
color: #FFFFFF;
height: 40px;
font-size: 14px;
background: ${COLOR_TEXT_MAIN};
font-weight: 800;
border-color: ${COLOR_TEXT_MAIN};
border-radius: 4px;
padding: 12px 24px;
text-transform: none;
:hover {
  background: #707889;
  border-color: #707889;
}
:disabled {
  background: #E6E7E8;
  color: rgba(75, 85, 106, 0.24);
  border: rgba(75, 85, 106, 0.24);
}
`);

export const PaperWarningButton = styled(LoadingButton)(`
color: #BF4140;
height: 40px;
font-size: 14px;
background: #FFFFFF;
font-weight: 800;
border: 1.5px solid #BF4140;
border-radius: 4px;
padding: 12px 24px;
text-transform: none;
:hover {
  background: #BF4140;
  border-color: #BF4140;
  color: #FFFFFF;
}
:disabled {
  background: #E6E7E8;
  color: rgba(75, 85, 106, 0.24);
  border: rgba(75, 85, 106, 0.24);
}
`);
